import Instance from "../../../Axios";

const GetPlusTipoEdificios = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/tipoEdificios`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_TIPO_EDIFICIOS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusTipoEdificios;
